// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 734 ? "136414c0" : chunkId) + "." + {"520":"019e1b65ec2f9821","734":"8237c1ecda0ee2b4"}[chunkId] + ".js";
};